import "jquery";
import * as ko from "knockout";
import { UserLoginApi } from "../apis/UserLoginApi";
import { LoginViewModel } from "../ViewModels/LoginViewModel";

export class UserLogin {
    private userApi: UserLoginApi;
    private loginViewModel: LoginViewModel;

    private $loginDiv: JQuery;
    private $passwordField: JQuery;
    private $impersonationDiv: JQuery;
    private $loginButtonDiv: JQuery;
    private $loginLoader: JQuery;
    private $loginBtn: JQuery;

    constructor() {
        this.userApi = UserLoginApi.getInstance();
        this.loginViewModel = new LoginViewModel();

        this.$loginDiv = $("#loginDiv");
        this.$passwordField = $("#Password");
        this.$impersonationDiv = $("#impersonationDiv");
        this.$loginButtonDiv = $("#loginButtonDiv");
        this.$loginBtn = $("#loginBtn");
        this.$loginLoader = $("#loader");

        if (this.$loginDiv[0]) {
            ko.applyBindings(this.loginViewModel, this.$loginDiv[0]);
        }
        if (this.$loginButtonDiv[0]) {
            ko.applyBindings(this.loginViewModel, this.$loginButtonDiv[0]);
        }
        if (this.$impersonationDiv[0]) {
            ko.applyBindings(this.loginViewModel, this.$impersonationDiv[0]);
        }
    }

    init(): void {
        const self = this;

        $('[data-action="submitLogin"]').on("submit",
            function(e: any) {
                e.preventDefault();
                self.$loginLoader.addClass("loading");
                self.$loginBtn.prop("disabled", true);
                const username = $(this).find("[name=Username]").val() as string;
                const password = $(this).find("[name=Password]").val() as string;
                const childSubUser = $(this).find('[name=childSubUser] option:selected').val() as string;
                self.login(username, password, childSubUser);
            });
    }

    private login(username: string, password: string, childSubUser: string): void {

        this.userApi.postUserLogin(username, password, childSubUser).then((res) => {
            if (res.LoginSuccessful && res.IsParentSubUser) {
                this.loginViewModel.showImpersonation(true);
                this.loginViewModel.childSubUsers(res.ChildSubUsers);
                this.$loginBtn.prop("disabled", false);
                this.$loginLoader.removeClass("loading");
            }
            else if (res.LoginSuccessful) {
                window.location.reload();
            }
            else if (!res.Activated) {
                this.loginViewModel.showPasswordFeedback(false);
                this.loginViewModel.showDeactivatedFeedback(true);
                this.$loginBtn.prop("disabled", false);
                this.$loginLoader.removeClass("loading");
            }
            else {
                this.loginViewModel.showDeactivatedFeedback(false);
                this.loginViewModel.showPasswordFeedback(true);
                this.$passwordField.val("");
                this.$loginBtn.prop("disabled", false);
                this.$loginLoader.removeClass("loading");
            }
        });
    }
}